module.exports = __webpack_public_path__ + "img/tema.e0e9a585.jpeg";